export class AccordionTextStyle {
  size = 'uk-h5';
  font = 'tb-font-primary';

  static normalize(styles: Partial<AccordionTextStyle>): AccordionTextStyle {
    const pureStyles = new AccordionTextStyle();

    pureStyles.size = styles.size ?? pureStyles.size;
    pureStyles.font = styles.font ?? pureStyles.font;

    return pureStyles;
  }
}
